import { Anchor, Text } from '@mantine/core';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { AuditLogType } from '@portals/types';

interface AddUserToGroupProps {
  auditLog: AuditLogType;
}

export const AddUserToGroup: FC<AddUserToGroupProps> = ({ auditLog }) => (
  <Text size="sm">
    Added {auditLog?.params[0]?.model}:{' '}
    <Anchor size="sm" component={Link} to="/settings/users_and_groups/users">
      {auditLog?.params[0]?.display_name}
    </Anchor>{' '}
    to {auditLog?.params[1]?.model}: {auditLog?.params[1]?.display_name}
    {auditLog?.params[2]?.name === 'tenant'
      ? ` (org: ${auditLog?.params[2]?.display_name})`
      : null}
  </Text>
);
